import HeaderSlidingMenu from './HeaderSlidingMenu';
export default HeaderSlidingMenu;